import { FlightRouteInfo, FullBaggageResponse, JsonsData } from '@/src/types/flight'
import { Box, Paper, Stack } from '@mui/material'
import FlightDetailsBox from './flightDetailsBox'

type FlightDetailsSectionProps = {
    sector: FlightRouteInfo
    jsons: JsonsData
    layOverDurationMap?: FlightRouteInfo['layoverDurationMap']
    baggageData: FullBaggageResponse | undefined
    loading: boolean
    error: string | null
    showBaggage?: boolean
    retryCount: number
    handleRetryBaggage: () => void
    maxRetries: number
}

const FlightDetailsSection = ({
    sector,
    jsons,
    layOverDurationMap,
    baggageData,
    loading,
    error,
    showBaggage,
    retryCount,
    handleRetryBaggage,
    maxRetries
}: FlightDetailsSectionProps) => {
    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between">
            <Stack spacing={2} px="1rem" pt="0.2rem" pb={2}>
                <Paper sx={{ p: 2, overflow: 'auto' }}>
                    {sector.flights.segments.map((segment, index) => (
                        <FlightDetailsBox
                            key={index}
                            segment={segment}
                            lastSegment={index === sector.flights.segments.length - 1}
                            jsons={jsons}
                            layOverDuration={layOverDurationMap?.[index]}
                            baggageData={baggageData}
                            loading={loading}
                            error={error}
                            showBaggage={showBaggage}
                            retryCount={retryCount}
                            handleRetryBaggage={handleRetryBaggage}
                            maxRetries={maxRetries}
                        />
                    ))}
                </Paper>
            </Stack>
        </Box>
    )
}

export default FlightDetailsSection
